module.exports = __webpack_public_path__ + "assets/star-orange-db26db.svg";